import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { Task } from '@/type';

import type { WorkReallocateRatioFormData } from '../type';
import { useDefaultReallocateRatioValue } from './useDefaultValue';

export const useWorkReallocateRatioForm = (
  task: Task,
): UseFormReturn<WorkReallocateRatioFormData> => {
  const { makeDefaultValue } = useDefaultReallocateRatioValue(task);

  const form = useForm<WorkReallocateRatioFormData>({
    defaultValues: makeDefaultValue(),
    mode: 'onChange',
  });

  const { trigger } = form;

  useEffect(() => {
    const validateAllFields = async () => {
      if (!task.userTask) return;

      await Promise.all(
        task.userTask
          .map((_, index) =>
            trigger(`distributions.${index}.allocateRatio` as const),
          )
          .concat(trigger('totalTaskRatio')),
      );
    };

    validateAllFields();
  }, [trigger, task.userTask]);

  return form;
};
